import Const from '../Const'
class EffectTools{
  constructor(Const){
    this.instance = null
  }
  static createEffectToolsClass(){
    if(!this.instance){
      this.instance = new EffectTools()
    }
    return this.instance
  }
  switchInputToEffect = (standardInput)=>{
    let data
    switch (standardInput.effect) {
      case Const.inputKey.open:
        data = this.effectOpen(standardInput.arguments)
        break;
      case Const.inputKey.clear:
        data = this.effectClear(standardInput.arguments)
        break;
      case Const.inputKey.clearList:
        data = this.effectClearList(standardInput.arguments)
        break;
      case Const.inputKey.clearInput:
        data = this.effectClearInput(standardInput.arguments)
        break;
      case Const.inputKey.baidu:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.baidu,standardInput.lastType)
        break;
      case Const.inputKey.ecosia:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.ecosia,standardInput.lastType)
        break;
      case Const.inputKey.google:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.google,standardInput.lastType)
        break;
      case Const.inputKey.yahoo:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.yahoo,standardInput.lastType)
        break;
      case Const.inputKey.bing:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.bing,standardInput.lastType)
        break;
      case Const.inputKey.qihu:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.qihu,standardInput.lastType)
        break;
      case Const.inputKey.sougou:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.sougou,standardInput.lastType)
        break;
      case Const.inputKey.soso:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.soso,standardInput.lastType)
        break;
      case Const.inputKey.tudou:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.tudou)
        break;
      case Const.inputKey.youku:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.youku)
        break;
      case Const.inputKey.qqVideo:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.qqVideo)
        break;
      case Const.inputKey.iqiyi:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.iqiyi)
        break;
      case Const.inputKey.bilibili:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.bilibili)
        break;
      case Const.inputKey.mgtv:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.mgtv)
        break;
      case Const.inputKey.sohutv:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.sohutv)
        break;
      case Const.inputKey.le:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.le)
        break;
      case Const.inputKey.acfun:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.acfun)
        break;
      case Const.inputKey.nico:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.nico)
        break;
      case Const.inputKey.youtube:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.youtube)
        break;
      case Const.inputKey.qqmusic:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.qqmusic)
        break;
      case Const.inputKey.xiamimusic:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.xiamimusic)
        break;
      case Const.inputKey.netmusic:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.netmusic)
        break;
      case Const.inputKey.kugoumusic:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.kugoumusic)
        break;
      case Const.inputKey.youtubemusic:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.youtubemusic)
        break;
      case Const.inputKey.baidumusic:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.baidumusic)
        break;
      case Const.inputKey.yinyuetai:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.yinyuetai)
        break;
      case Const.inputKey.qqmusicmv:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.qqmusicmv)
        break;
      case Const.inputKey.playQQMusic:
        return standardInput.arguments.length !== 0 ?
        this.effectPlayQQMusic(standardInput.arguments) :
        {
          state: Const.executeKey.error
          ,url: ""
        }
      case Const.inputKey.playQQMusicMv:
        return standardInput.arguments.length !== 0 ?
        this.effectPlayQQMusicMv(standardInput.arguments) :
        {
          state: Const.executeKey.error
          ,url: ""
        }
      case Const.inputKey.zhihu:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.zhihu)
        break;
      case Const.inputKey.baiduzhidao:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.baiduzhidao)
        break;
      case Const.inputKey.baidubaike:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.baidubaike)
        break;
      case Const.inputKey.sougoubaike:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.sougoubaike)
        break;
      case Const.inputKey.qihubaike:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.qihubaike)
        break;
      case Const.inputKey.baidubaikeSearch:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.baidubaikeSearch)
        break;
      case Const.inputKey.hudongbaike:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.hudongbaike)
        break;
      case Const.inputKey.wikibaike:
        data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.wikibaike)
        break;

      case Const.inputKey.baiduxinwen:
      data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.baiduxinwen)
      break;
      case Const.inputKey.qqxinwen:
      data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.qqxinwen)
      break;
      case Const.inputKey.sohuxinwen:
      data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.sohuxinwen)
      break;
      case Const.inputKey.sinaxinwen:
      data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.sinaxinwen)
      break;
      case Const.inputKey.taobao:
      data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.taobao)
      break;
      case Const.inputKey.tmall:
      data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.tmall)
      break;
      case Const.inputKey.jd:
      data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.jd)
      break;
      case Const.inputKey.amazon:
      data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.amazon)
      break;
      case Const.inputKey.amazoncn:
      data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.amazoncn)
      break;
      case Const.inputKey.github:
      data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.github)
      break;
      case Const.inputKey.oschina:
      data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.oschina)
      break;
      case Const.inputKey.segmentfault:
      data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.segmentfault)
      break;
      case Const.inputKey.stackoverflow:
      data = this.effectLikeSearch(standardInput.arguments,Const.inputKey.stackoverflow)
      break;
      
      default:

    }
    return data
  }
  effectOpen = (args)=>{
    let data = {
      state: Const.executeKey.success
      ,url: ""
    }
    if(args.length === 0)
    {
      data.state = Const.executeKey.error
      return data
    }
    data.url = Const.openSites.get(args[0])
    return data
  }
  effectClear = (args)=>{
    let data = {
      state: Const.executeKey.success
      ,url: ""
    }
    localStorage.removeItem(Const.storageKey.inputValue)
    sessionStorage.clear()
    return data
  }
  effectClearList = (args)=>{
    sessionStorage.removeItem(Const.storageKey.playQQMusic)
    return {state: Const.executeKey.success ,url: ""}
  }
  effectClearInput = (args)=>{
    localStorage.removeItem(Const.storageKey.inputValue)
    return {state: Const.executeKey.success ,url: ""}
  }

  effectLikeSearch = (args, value, lastType=null)=>{
    let data = {
      state: Const.executeKey.success
      ,url: ""
    }
    if(args.length === 0)
      args = [""]
    data.url = Const.httpApi.get(value).firstHalf +
    args.reduce((x,y)=>x+" "+y) +
    Const.httpApi.get(value).secondHalf
    if(lastType === Const.inputKey.open){
      data.state = Const.executeKey.warning
    }
    return data
  }

  effectPlayQQMusic = async (args)=>{
    let songs = []
    let errorCount = []
    for (let i = 0; i < args.length; i++) {
      const firstRandom = this.randomStringkBuilder(17)
      const secondRandom = this.randomStringkBuilder(16)
      songs[i] = await Const.outFunctions.fetchJsonp(
        Const.httpApi.get(Const.inputKey.playQQMusic).firstHalf.replace("9527",firstRandom)+
        args[i]+
        Const.httpApi.get(Const.inputKey.playQQMusic).secondHalf.replace("9527",secondRandom),
        {jsonpCallbackFunction: "MusicJsonCallback"+secondRandom}
      ).then(function(response) {
        return response.json()
      }).catch((e) => {
        errorCount.push(i)
      })
    }
    return {
      type: Const.inputKey.playQQMusic
      ,songs: songs
      ,errorCount: errorCount
    }
  }
  effectPlayQQMusicMv = async (args)=>{
    let songs = []
    let errorCount = []
    for (let i = 0; i < args.length; i++) {
      const firstRandom = this.randomStringkBuilder(17)
      const secondRandom = this.randomStringkBuilder(16)
      songs[i] = await Const.outFunctions.fetchJsonp(
        Const.httpApi.get(Const.inputKey.playQQMusicMv).firstHalf.replace("9527",firstRandom)+
        args[i]+
        Const.httpApi.get(Const.inputKey.playQQMusicMv).secondHalf.replace("9527",secondRandom),
        {jsonpCallbackFunction: "MusicJsonCallback"+secondRandom}
      ).then(function(response) {
        return response.json()
      }).catch((e) => {
        errorCount.push(i)
      })
    }
    return {
      type: Const.inputKey.playQQMusicMv
      ,songs: songs
      ,errorCount: errorCount
    }
  }
  randomStringkBuilder = (count)=>{
    let randomString = ""
    for(let i = 0; i < count; i++)
    {
      randomString += Math.abs(Math.floor(Math.random()*10 - 0.0001)).toString()
    }
    return randomString
  }
}
export default EffectTools



// WEBPACK FOOTER //
// ./src/toolsClass/EffectTools.js